import { tenantsApiClient } from '@owl-frontend/api-client';
import { asyncActionStateMatchers, invoke } from '@owl-frontend/redux';
import tenantSlice from './interface';

const slice = tenantSlice
  .addAsyncSagas({
    fetchTenant: invoke(tenantsApiClient.tenant.get),
  })
  .addReducers({
    'fetchTenant/fulfilled': (state, action) => {
      state.tenant = action.payload;
    },
  });

export const actions = slice.actions;
export default slice.addExtra(asyncActionStateMatchers(actions).all());
